import { useAppCard } from '../model';

import { AppAvatar } from './AppAvatar';

const Avatar = () => {
  const { data } = useAppCard();
  const { owned, name, appId, claimed, brandLogo, brandColor } = data;

  return (
    <AppAvatar
      appId={appId}
      name={name}
      claimed={claimed}
      shape={owned ? 'circle' : 'rounded-square'}
      logoUrl={brandLogo}
      brandColor={brandColor}
    />
  );
};

export { Avatar };
